import React, { Fragment } from "react";
import { Heading } from "../Heading";
import { Box } from "@mui/material";
import { OptionButton, SubmitButton } from "../Buttons";

const StepSix = ({ handleSubmit, setFormData, formData }) => {
  const [selectedOption, setSelectedOption] = React.useState(
    formData.additionalLoans || null
  );
  const options = [
    { id: 1, name: "option 1", value: "לא", label: "לא" },
    {
      id: 2,
      name: "option 2",
      value: "כן, פחות מחצי מיליון",
      label: "כן, פחות מחצי מיליון",
    },
    {
      id: 3,
      name: "option 3",
      value: "כן, יותר מחצי מיליון",
      label: "כן, יותר מחצי מיליון",
    },
  ];

  const submitStep = () => {
    if (selectedOption) {
      setFormData((prevState) => ({
        ...prevState,
        additionalLoans: selectedOption,
      }));
      handleSubmit({ additionalLoans: selectedOption });
    }
  };

  return (
    <Fragment>
      <Heading styles={{ marginBottom: "62px", direction: "rtl" }}>
        האם קיימות עוד הלוואות נוספות?
      </Heading>
      <Box
        display="flex"
        gap="20px"
        sx={{
          "@media (max-width:538px)": {
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "10px",
          },
        }}
      >
        {options?.map((option) => (
          <OptionButton
            selected={option.value === selectedOption}
            label={option.label}
            key={option.id}
            handleClick={() => setSelectedOption(option.value)}
            buttonStyles={{ width: "100%", direction: option.direction }}
          />
        ))}
      </Box>
      <SubmitButton
        label="המשך"
        handleClick={submitStep}
        wrapperStyles={{ marginTop: "50px" }}
      />
    </Fragment>
  );
};

export default StepSix;
